export class HostUtils {
  static getHostname(): string {
    return window.location.hostname
  }
}

